<template>
  <div class="old_hw">
    <div class="old_hw__button" v-if="!show_variants">
      <a class="" @click="show_variants = !show_variants">Выбрать основу для ДЗ</a>
    </div>
    <ul class="old_hw__items" v-show="show_variants">
      <li class="old_hw__item" v-for="item in items" :key="item.id">
        <OldHwItem :item="item" @onSelectHW="onSelectHW" />
      </li>
    </ul>
  </div>
</template>

<script>
import OldHwItem from "./OldHwItem";

export default {
  name: "old_hw_select",
  components: {
    OldHwItem
  },
  watch: {
    'items': 'onChangeItems'
  },
  data() {
    return {
      show_variants: false
    }
  },
  props: {
    items: ''
  },
  methods: {
    onSelectHW(item){
      this.$emit('onSelectHW', item);
      this.show_variants = false;
    },
    onChangeItems(){
      console.log('change items');
      this.show_variants = false;
    }
  },
}
</script>

